module.exports = __webpack_public_path__ + "img/LG_horizontal-blue-shape-progression-06.c8eeb75f.png";